import { store } from 'models/store';

export default function (response) {
	store
		.getState()
		.setUpdateRequired(response.headers['x-update-required'] === 'true');

	return response;
}
